import EcoBlogCard from 'eco-design/sections/eco-blog-items/eco-blog-card';
import GloLayout from 'lowcode/common/GloLayout';
import { useRouter } from 'next/router';
import { Fragment, useEffect, useState } from 'react';
import { queryCategoryItemsList } from '../../common/blog-api/queryCategoryItems';
import BlogTimer from '../../common/blog-timer';
import { getBlogTagFromList } from '../../common/utils';
import './index.scss';

export default function Content({ id, data, initIndex = 0, isEditStatus = false }: any) {
    const { list = [], items = [] } = data;
    const { locale = 'us' } = useRouter();
    const [itemsA, setItemsA] = useState(items);

    // 切换数据
    const getItemsForNone = async (idsA: string[]) => {
        if (!idsA.length) {
            return;
        }

        const dataA = await queryCategoryItemsList(locale, {
            ids: idsA,
        });
        setItemsA(dataA);
    };
    useEffect(() => {
        const initHandle = () => {
            if (!isEditStatus) {
                return;
            }
            const idsA: string[] = [];
            list.forEach((item: any) => {
                if (item.blogId) {
                    idsA.push(item.blogId);
                }
            });
            getItemsForNone(idsA);
        };
        initHandle();
    }, [list]);

    return (
        <GloLayout className="editor-blog-list-free" id={id}>
            <div className="editor-blog-list-free-c eco-content">
                {itemsA?.map((item: any, index: number) => {
                    const thePage = JSON.parse(item.thePage || '{}');
                    const tagItem = getBlogTagFromList(item.blogTagList || [], '');

                    return (
                        <Fragment key={index}>
                            <EcoBlogCard
                                categoryHref={`/${locale}/blog/category/${tagItem.tagUrl}`}
                                label={tagItem.tag}
                                title={thePage.blogTitle}
                                pc={thePage.blogImgPc}
                                h5={thePage.blogImgH5}
                                href={item.seoUrl}
                                timer={BlogTimer(item.newFirstReleaseTime || item.firstReleaseTime, locale)}
                            />
                        </Fragment>
                    );
                })}
            </div>
        </GloLayout>
    );
}
